export const routes = {
  authentication: {
    loginEmail: '/api/auth/login/',
    passwordResetSend: '/api/auth/password-reset/send/',
    passwordResetConfirm: '/api/auth/password-reset/confirm/',
    logOut: 'api/auth/logout/',
    sessionLogOut:'api/auth/sessions/revoke/',
  },
  services: {
    // getVideoListDemo: (date: any, uuid: any) => `/api/devices/${uuid}/get-slots/${date}/`,
    getVideoListDemo: (date: any, uuid: any,tunnelUrl:any) => `${String(tunnelUrl).replace(/\/+$/, '')}/recordings/dates?date=${date}`,
    getDeviceDetails: "/api/device-details/",
    //avalableDateForDevice: (uuid: any) => `api/devices/${uuid}/get-dates/`,
    avalableDateForDevice: (uuid: any,tunnelUrl:any) => `${String(tunnelUrl).replace(/\/+$/, '')}/get-dates`,
    getAlarmAddress: (e: any) => `/api/lat-long-address?lat=${e?.st_lt}&long=${e?.st_long}`,
    allDevicesList: "api/devices/",
    deviceWiseAnalatics: (
      startData: any,
      endDate: any,
      zone: any,
      activeCarDetails: any
    ) => {
      const baseUrl = `api/devices/${activeCarDetails}/ai-data-zst/${startData}/${endDate}`;
      return zone
        ? `${baseUrl}?region=${zone}`
        : baseUrl;
    },
    deviceWiseZone: (startData: any, endDate: any, uid: any) => `api/devices/${uid}/ai-events-between/?start_datetime=${startData}&end_datetime=${endDate}`,
    devicePedZoneData: (startData: any, endDate: any, uid: any) => `api/devices/${uid}/ped-zone-data/${startData}/${endDate}/`,
    deviceTtc: (startData: any, endDate: any, uid: any) => `api/devices/${uid}/ttc-data/${startData}/${endDate}/`,
    devicePet: (startData: any, endDate: any, uid: any) => `api/devices/${uid}/pet-data/${startData}/${endDate}/`,
    deviceZoneWiseCount: (startData: any, endDate: any, uid: any) => `get-zone-live?date=${startData}`,
    deviceExportData: (startData: any, endDate: any, deviceId: any) => `api/devices/${deviceId}/export-csv/${startData}/${endDate}/`,
    deviceExportDataPet: (startData: any, endDate: any, deviceId: any) => `api/devices/${deviceId}/export-pet/${startData}/${endDate}/`,
    deviceExportDataTtc: (startData: any, endDate: any, deviceId: any) => `api/devices/${deviceId}/export-ttc/${startData}/${endDate}/`,
    autoDelete: (id: any) => `api/devices/${id}/settings/camera/`,
    ttcData: (uuid:any,date: any) => `api/devices/${uuid}/ttc-data-zst/${date?.start_datetime}/${date?.end_datetime}`,
    petData: (uuid:any,date: any) => `api/devices/${uuid}/pet-data-zst/${date?.start_datetime}/${date?.end_datetime}`,
    ttcPetLine: 'get-lines-ttc',
    updateDeviceData: (id: any) => `api/devices/${id}/`,
    getDeviceDetailsById: (id: any) => `api/devices/${id}/`,
    deleteDeviceLineByName: (name: any, type: any) => `delete-line?line_name=${name}`,
    editLineZone: '/rename-line',
    getDeviceImage: 'api/auth/generate-signed-url/',
    getDeviceUploadImage: "api/auth/upload-image/",
    getLineDataDayWise: (dateSelect: any, tunnelUrl: any) => `${String(tunnelUrl).replace(/\/+$/, "")}/recordings_json/${dateSelect}/all_ai_results.json`,
    getNetworkData: (id: any) => `/api/devices/${id}/settings/network/`,
    getUserList: '/api/auth/admin/users/',
    createUser: '/api/auth/register/',
    deleteUser: (id: any) => `/api/auth/admin/users/${id}/delete/`,
    updateUser: (id: any) => `api/auth/admin/users/${id}/`
  }
};